import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InstitutionTypeForm from '../../InstitutionTypeForm';
import { validateEntityName } from '../../../../../helpers/validateGeneric';
import { RowSummary } from '../../../SharedSC/DashboardSC';

const Layout = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  background: ${props => props.theme.colors.white};
`;

const EditInstitutionSubtype = ({
  existingInstitutionSubtype,
  allSiblings,
  handleChange,
  onPutUpdate,
  showValidationErrors,
  toggleEditView
}) => (
  <Layout>
    <RowSummary>
      <InstitutionTypeForm
        isEditForm
        type={existingInstitutionSubtype}
        entityLabel="Subtype"
        buttonText="Update"
        handleChange={event => handleChange(event)}
        onSubmit={onPutUpdate}
        showValidationErrors={showValidationErrors}
        validateName={() =>
          validateEntityName(existingInstitutionSubtype.name, allSiblings)
        }
        onFormClose={() => toggleEditView()}
      />
    </RowSummary>
  </Layout>
);

EditInstitutionSubtype.propTypes = {
  existingInstitutionSubtype: PropTypes.object,
  showValidationErrors: PropTypes.bool,
  allSiblings: PropTypes.arrayOf(PropTypes.object),
  handleChange: PropTypes.func,
  onPutUpdate: PropTypes.func,
  toggleEditView: PropTypes.func
};
EditInstitutionSubtype.defaultProps = {
  existingInstitutionSubtype: {},
  showValidationErrors: false,
  allSiblings: [],
  handleChange: undefined,
  onPutUpdate: undefined,
  toggleEditView: undefined
};

export default EditInstitutionSubtype;
